<template>
	<div class="col-12 col-md-6 col-lg-4 d-flex">
		<div class="card news-card border-0 align-items-stretch w-100 rounded-4">
			<template v-if="true == useHardLink && showPictureTag">
				<div class="ratio ratio-16x9 overflow-hidden position-relative w-100">
					<a :href="model.link" aria-label="Link to read full article" itemprop="url" class="h-100 w-100 position-absolute d-flex align-items-center overflow-hidden">
						<event-picture :image="model.images" :alt="model.title" :classes="['cover-img', 'rounded-top-4']"></event-picture>
					</a>
				</div>
			</template>
			<template v-if="false == useHardLink && showPictureTag">
				<div class="ratio ratio-16x9 overflow-hidden position-relative w-100">
					<router-link :to="model.link" :key="$route.fullPath" v-if="showPictureTag" class="h-100 w-100 position-absolute d-flex align-items-center overflow-hidden">
						<event-picture :image="model.images" :alt="model.title"
							:classes="['cover-img', 'rounded-top-4']"></event-picture>
					</router-link>
				</div>
			</template>
			<div class="card-body d-flex flex-column justify-content-between">
				<div class="card-wrapper">
					<h3 class="card-title mb-2 h5" v-if="model.title">
						<template v-if="true == useHardLink">
							<a :href="model.link" class="nice-hover nice-bottom position-relative pb-2 d-block" v-html="model.title"></a>
						</template>
						<template v-if="false == useHardLink">
							<router-link :to="model.link" :key="$route.fullPath" class="nice-hover nice-bottom position-relative pb-2 d-block" v-html="model.title"></router-link>
						</template>
					</h3>
					<div class="post-excerpt mt-2">
						<p class="card-text" v-html="model.excerpt"></p>
					</div>
				</div>
				<template v-if="true == useHardLink">
					<a :href="model.link" class="nice-hover nice-top grota-font position-relative d-block d-flex align-items-center justify-content-between text-uppercase pt-2 mt-3">
						Read more <span class="sr-only">of this article</span> <i class="ms-2 fal fa-angle-right"></i>
					</a>
				</template>
				<template v-if="false == useHardLink">
					<router-link :to="model.link" :key="$route.fullPath" class="nice-hover nice-top grota-font position-relative d-block d-flex align-items-center justify-content-between text-uppercase pt-2 mt-3">
						Read more <span class="sr-only">of this article</span> <i class="ms-2 fal fa-angle-right"></i>
					</router-link>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import EventPicture from '@/components/EventPicture.vue';

export default {
	name: 'EventCard',
	props: {
		model: Object
	},
	components: {
		EventPicture
	},
	data() {
		return {
			useHardLink: ('1' === process.env.VUE_APP_USE_SINGLE_POST_HARD_LINK || false),
			isOpen: false
		}
	},
	computed: {
		showPictureTag() {
			if (this.model.images && Object.keys(this.model.images).length && this.model.images.full && this.model.images.full.url) {
				return true;
			}
			return false
		}
	},
	mounted() {
		console.log('useHardLink', this.useHardLink)
	}
}
</script>

<style scoped lang="scss">
.event-card {
	position: relative;
}
</style>
